import React, { useEffect, useState } from 'react';
import { useToast } from '../context/ToastContext';
import { mensajeAmigable } from '../utils/errores';
import { limpiarTexto } from '../utils/validacion';
import { obtenerClientes } from '../services/clientesService';
import { obtenerServicios } from '../services/serviciosService';
import { crearCita, actualizarCita } from '../services/citasService';
import { DURACIONES, hoyISO } from '../utils/citas';

const P = 'var(--color-primario,#DB2777)';
const input = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };
const label = { display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 600, color: '#374151' };

// `inicial` = datos precargados al CREAR (ej. desde una cotización aprobada).
export default function CitaForm({ cita = null, inicial = null, onCerrar, onGuardado }) {
  const editando = !!cita;
  const base = cita || inicial || {};
  const { mostrarToast } = useToast();
  const [clientes, setClientes] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [guardando, setGuardando] = useState(false);

  const [clienteId, setClienteId] = useState(base.cliente_id || '');
  const [clienteNombre, setClienteNombre] = useState(base.cliente_nombre || '');
  const [servicioId, setServicioId] = useState(base.servicio_id || '');
  const [fecha, setFecha] = useState(base.fecha || hoyISO());
  const [hora, setHora] = useState(base.hora ? String(base.hora).slice(0, 5) : '');
  const [duracion, setDuracion] = useState(base.duracion_min != null ? String(base.duracion_min) : '');
  const [enlaceReunion, setEnlaceReunion] = useState(base.enlace_reunion || '');
  const [notas, setNotas] = useState(base.notas || '');

  useEffect(() => {
    obtenerClientes().then(setClientes).catch(() => {});
    obtenerServicios().then(setServicios).catch(() => {});
  }, []);

  const elegirCliente = (id) => {
    setClienteId(id);
    if (id) { const c = clientes.find((x) => x.id === id); setClienteNombre(c?.nombre || ''); }
  };

  const guardar = async () => {
    if (!fecha) { mostrarToast('Elige la fecha de la cita', 'error'); return; }
    if (!clienteId && !clienteNombre.trim() && !servicioId) {
      mostrarToast('Pon al menos el cliente o el servicio de la cita', 'error'); return;
    }
    setGuardando(true);
    try {
      const serv = servicios.find((s) => s.id === servicioId);
      const datos = {
        cliente_id: clienteId || null,
        cliente_nombre: clienteNombre.trim() || null,
        servicio_id: servicioId || null,
        servicio_nombre: serv?.nombre || base.servicio_nombre || null,
        fecha,
        hora: hora || null,
        duracion_min: duracion ? Number(duracion) : null,
        enlace_reunion: enlaceReunion.trim() || null,
        notas: notas.trim() || null,
        cotizacion_id: base.cotizacion_id || null,
      };
      if (editando) await actualizarCita(cita.id, datos);
      else await crearCita({ ...datos, estado: 'programada' });
      mostrarToast(editando ? 'Cita actualizada ✅' : 'Cita agendada 📅', 'exito');
      onGuardado && onGuardado();
      onCerrar();
    } catch (e) {
      mostrarToast(mensajeAmigable(e), 'error');
      setGuardando(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '14px' }} onClick={guardando ? undefined : onCerrar}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', padding: '22px', width: '440px', maxWidth: '100%', maxHeight: '92vh', overflowY: 'auto', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ margin: 0, color: P, fontSize: '19px' }}>{editando ? '✏️ Editar cita' : '📅 Nueva cita'}</h2>
          <button onClick={onCerrar} disabled={guardando} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
        </div>

        <label style={label}>Cliente</label>
        <select value={clienteId} disabled={guardando} onChange={(e) => elegirCliente(e.target.value)} style={{ ...input, marginBottom: '8px' }}>
          <option value="">— Sin cliente / escribir abajo —</option>
          {clientes.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
        </select>
        {!clienteId && (
          <input value={clienteNombre} disabled={guardando} maxLength={80} placeholder="O escribe el nombre del cliente"
            onChange={(e) => setClienteNombre(limpiarTexto(e.target.value, 80))} style={{ ...input, marginBottom: '12px' }} />
        )}
        {clienteId && <div style={{ marginBottom: '12px' }} />}

        <label style={label}>Servicio (opcional)</label>
        <select value={servicioId} disabled={guardando} onChange={(e) => setServicioId(e.target.value)} style={{ ...input, marginBottom: '12px' }}>
          <option value="">— Ninguno —</option>
          {servicios.map((s) => <option key={s.id} value={s.id}>{s.nombre}</option>)}
        </select>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
          <div>
            <label style={label}>Fecha *</label>
            <input type="date" value={fecha} disabled={guardando} onChange={(e) => setFecha(e.target.value)} style={input} />
          </div>
          <div>
            <label style={label}>Hora</label>
            <input type="time" value={hora} disabled={guardando} onChange={(e) => setHora(e.target.value)} style={input} />
          </div>
        </div>

        <label style={label}>Duración</label>
        <select value={duracion} disabled={guardando} onChange={(e) => setDuracion(e.target.value)} style={{ ...input, marginBottom: '12px' }}>
          <option value="">Sin definir</option>
          {DURACIONES.map((d) => <option key={d.valor} value={d.valor}>{d.label}</option>)}
        </select>

        <label style={label}>🎥 Enlace de reunión (Zoom / Meet, opcional)</label>
        <input type="url" value={enlaceReunion} disabled={guardando} maxLength={500}
          onChange={(e) => setEnlaceReunion(e.target.value)} style={{ ...input, marginBottom: '12px' }}
          placeholder="Pega aquí el link de Zoom o Google Meet" />

        <label style={label}>Nota (opcional)</label>
        <textarea value={notas} disabled={guardando} rows={2} maxLength={500}
          onChange={(e) => setNotas(e.target.value)} style={{ ...input, fontFamily: 'inherit', resize: 'vertical', marginBottom: '16px' }}
          placeholder="Ej. Lugar, detalle, qué llevar…" />

        <button onClick={guardar} disabled={guardando}
          style={{ width: '100%', padding: '14px', background: guardando ? '#9CA3AF' : P, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: 'bold', cursor: guardando ? 'wait' : 'pointer' }}>
          {guardando ? '⏳ Guardando…' : (editando ? 'Guardar cambios' : 'Agendar cita')}
        </button>
      </div>
    </div>
  );
}
